import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useToast } from 'hooks/ui';
import { useApplicationStore } from 'store/application';
import { commentKeys } from './queryKeys';
import { deleteTaskComment } from 'api/comment.service';

export const useTaskCommentDeleteQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { setLoading, removeLoading } = useApplicationStore();

  const { isPending, mutate } = useMutation({
    mutationFn: (info: { taskId: string; commentId: string }) => {
      setLoading();

      return deleteTaskComment(info.commentId);
    },
    onSuccess: () => {
      toast.success('Comment has been deleted successfully');
    },
    onError: (error: AxiosError) => toast.error(error.message),
    onSettled: (_comment, _error, info) => {
      removeLoading();
      queryClient.invalidateQueries({
        queryKey: commentKeys.task(info.taskId),
      });
    },
  });

  return { isLoading: isPending, mutate };
};
